/**
 * Ürün medyası videoları için otomatik oynatma + sol alt durdur/devam kontrolü.
 * Videolar sessiz, döngülü ve satır içi (inline) oynar; ekrandan çıkınca duraklar.
 */
(function () {
  'use strict';

  var WRAPPER_SELECTOR = '[data-product-video]';
  var TOGGLE_SELECTOR = '[data-product-video-toggle]';

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function safePlay(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        /* Tarayıcı otomatik oynatmayı engelledi — sessizce yoksay */
      });
    }
  }

  function initVideo(wrapper) {
    if (!wrapper || wrapper.dataset.productVideoReady === 'true') return;

    var video = wrapper.querySelector('video');
    if (!video) return;

    wrapper.dataset.productVideoReady = 'true';

    var toggle = wrapper.querySelector(TOGGLE_SELECTOR);
    var userPaused = false;
    var reduceMotion = prefersReducedMotion();

    // Otomatik oynatma için gerekli özellikleri garantiye al
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.loop = true;
    video.controls = false;
    video.removeAttribute('controls');

    function updateUI() {
      var isPlaying = !video.paused && !video.ended;
      wrapper.classList.toggle('is-playing', isPlaying);

      if (toggle) {
        var label = isPlaying
          ? toggle.getAttribute('data-label-pause')
          : toggle.getAttribute('data-label-play');
        if (label) toggle.setAttribute('aria-label', label);
      }
    }

    function tryPlay() {
      if (userPaused || reduceMotion) return;
      safePlay(video);
    }

    video.addEventListener('play', updateUI);
    video.addEventListener('playing', updateUI);
    video.addEventListener('pause', updateUI);
    video.addEventListener('ended', updateUI);

    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (video.paused || video.ended) {
          userPaused = false;
          safePlay(video);
        } else {
          userPaused = true;
          video.pause();
        }
      });
    }

    // Görünür alandayken oynat, çıkınca duraklat
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              tryPlay();
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.2 }
      );

      observer.observe(wrapper);
    } else {
      tryPlay();
    }

    // Sekme arka plana alınınca duraklat, geri dönünce devam et
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (!video.paused) video.pause();
      } else if (!userPaused) {
        tryPlay();
      }
    });

    updateUI();
  }

  function initAll(root) {
    var scope = root || document;
    var wrappers = scope.querySelectorAll(WRAPPER_SELECTOR);
    for (var i = 0; i < wrappers.length; i++) {
      initVideo(wrappers[i]);
    }
  }

  function boot() {
    initAll(document);

    // Varyant değişimi / hızlı görünüm gibi sonradan eklenen medyalar için
    if ('MutationObserver' in window) {
      var mutationObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.matches && node.matches(WRAPPER_SELECTOR)) {
              initVideo(node);
            } else if (node.querySelectorAll) {
              initAll(node);
            }
          }
        }
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Tema düzenleyici uyumluluğu
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
